import React from 'react';
import Dropzone from 'react-dropzone';
import { Container, ContainerItem, H4, Subtitle, Trash, DownloadIcon } from '../index';
import ProgressBar from './ProgressBar';
import FileListContainer from './FileListContainer';
import FileAreaObject from './FileAreaObject';
import useTheme from '@material-ui/core/styles/useTheme';

/*eslint-disable */
const styles = {
  wrapper: {
    minHeight: '145px',
    display: 'flex',
  },
  uploaderStyle: {
    border: '1px dashed #979797',
    borderRadius: 3,
    backgroundColor: 'white',
    height: '100%',
    padding: 0,
    marginTop: 0,
    overflow: 'hidden',
    cursor: 'pointer',
  },
  uploaderStyleDisabled: {
    border: '1px dashed #979797',
    borderRadius: 3,
    backgroundColor: 'white',
    color: 'red',
    height: '100%',
    padding: 0,
    marginTop: 10,
    overflow: 'hidden',
    pointerEvents: 'none',
    cursor: 'pointer',
  },
  disabledText: {
    color: '#b4b4b4',
  },
  textBlock: {
    height: 145,
    lineHeight: 86,
    display: 'flex',
    outline: 'none',
    paddingTop: 0,
  },
  textBlockActive: {
    height: 145,
    lineHeight: 86,
    display: 'flex',
    outline: 'none',
    paddingTop: 0,
    backgroundColor: '#e4e4e4',
  },
  subtitleStyle: {
    marginTop: 5,
  },
  liStyle: {
    textAlign: 'initial' as 'initial',
    wordBreak: 'break-all' as 'break-all',
    paddingTop: 4,
    width: '100%',
    display: 'flex',
    span: {
      paddingRight: 10,
      cursor: 'pointer',
    },
  },
  rejectFile: {
    color: 'red',
    marginTop: 3,
    fontSize: 13,
  },
  contentStyle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  titleWithIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleStyle: {
    marginTop: 13,
    marginLeft: 10,
  },
  loadingItem: {
    position: 'relative',
  },
  loadingText: {
    color: '#616161',
    fontSize: '10px',
    position: 'absolute' as any,
    top: '50%',
    left: 'calc(50% + 3px)', // we add 3px becasue of the percentage sign we want to shift everything a bit to the right
    transform: 'translate(-50%, -50%)',
  },
};

interface Props {
  files: Array<FileAreaObject>;
  type?: any;
  isLoading?: boolean;
  onDelete?: any;
  progressBarColor?: string;
  textBoldTitle?: string;
  textSubtitle?: string;
  dragRejectText?: string;
  percentUploaded?: any;
  textUploading?: string;
  onDrop: any;
  AcceptFiles: any;
}

const FileArea = ({
  type,
  files: propFiles,
  isLoading,
  onDelete,
  progressBarColor,
  textBoldTitle,
  textSubtitle,
  dragRejectText,
  percentUploaded,
  textUploading,
  onDrop,
  AcceptFiles,
}: Props) => {
  const theme = useTheme();
  const files = propFiles.map((file: FileAreaObject, index: number) => (
    <li key={file.name} style={styles.liStyle}>
      <span
        style={styles.liStyle.span}
        data-name={file.name}
        data-type={type}
        onClick={(e) => (isLoading ? '' : onDelete(e))}
        onKeyUp={(e) => (isLoading ? '' : onDelete(e))}
        role="button"
        tabIndex={index}
      >
        <Trash height={6} width={6} color={isLoading ? '#a5a5a5' : progressBarColor} />
      </span>
      <Subtitle>{file.displayName}</Subtitle>
    </li>
  ));
  return (
    <Dropzone onDrop={onDrop} accept={AcceptFiles}>
      {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
        <Container>
          <ContainerItem
            xs={12}
            alignItems="center"
            style={{
              ...(isLoading ? styles.uploaderStyleDisabled : styles.uploaderStyle),
              ...styles.wrapper,
            }}
          >
            {!isLoading && (
              <Container direction="column" alignItems="center">
                <div {...getRootProps()} style={isDragActive ? styles.textBlockActive : styles.textBlock}>
                  <input {...getInputProps()} />
                  <ContainerItem xs={12} alignItems="center" style={styles.contentStyle}>
                    <div style={styles.titleWithIcon}>
                      <DownloadIcon color1={theme.extraColors.gradientLeft} color2={theme.extraColors.gradientRight} />
                      <H4 style={isLoading ? styles.disabledText : styles.titleStyle}>{textBoldTitle}</H4>
                    </div>
                    <Subtitle variant="subtitle1" style={isLoading ? styles.disabledText : styles.subtitleStyle}>
                      {textSubtitle}
                    </Subtitle>
                    {isDragReject && (
                      <Subtitle variant="subtitle2" style={styles.rejectFile}>
                        {isDragReject && dragRejectText}
                      </Subtitle>
                    )}
                  </ContainerItem>
                </div>
              </Container>
            )}
            {isLoading && (
              <Container direction="column" alignItems="center">
                <ContainerItem style={styles.loadingItem}>
                  <ProgressBar percentage={percentUploaded} progressBarColor={progressBarColor} />
                  <span style={styles.loadingText}>{`${percentUploaded}%`}</span>
                </ContainerItem>
                <ContainerItem>
                  <Subtitle variant="subtitle2">{textUploading}</Subtitle>
                </ContainerItem>
              </Container>
            )}
          </ContainerItem>

          {files.length > 0 && <FileListContainer files={files} />}
        </Container>
      )}
    </Dropzone>
  );
};

export default FileArea;
